import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const InorganicComplexesOrganometallics = () => (
  <QPhototModuleSubtopic
    title="Inorganic complexes and organometallics"
    videos={[
      "https://www.youtube.com/embed/r4H5XjJPn58",
      "https://www.youtube.com/embed/x4qDjP-1d2M",
      "https://www.youtube.com/embed/3_hJmSxCmw4",
      "https://www.youtube.com/embed/pgc8uo8UzAk",
      "https://www.youtube.com/embed/eGJ3aaQ9sCM",
      "https://www.youtube.com/embed/bZ9yjCK86Ms",
      "https://www.youtube.com/embed/Y9CAnuI6CEI"
    ]}
    takeaways={[
      { text: "EAN and 18 electron rule are important of inorganic complexes and metal carbonyls." },
      { text: "Study all the applications of inorganic complexes." },
      { text: "Can expect questions on CFT." },
      { text: "Ferrocene structure, applications, Stability related questions can expect." }
    ]}
    questions={[
      {
        text: "Depict the structure , bonding and any two applications of ferrocene?  ",
        
      },

      {
        text:"How are co-ordination compounds involved in the following process (i)Extraction of noble metal from their ore, (ii)Qualitative analysis of metal ion. "

      },

      {
        image:"/ch_1.jpeg"
      },

      {
        image:"/ch_2.jpeg"
      }
     
    ]}
    exampleVideos={[]}
  />
);

export default InorganicComplexesOrganometallics;
